import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import List from './components/List'
import New from './components/New'
import Update from './components/Update'
import UpdateAdvanced from './components/UpdateAvanced'
import Identity from './components/Identity'
import DepartmentDetail from './components/DepartmentDetail'

const EmployeeModule: RouteObject = {
    path: 'employees',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'new',
            element: <New />,
        },
        {
            path: ':id/update',
            element: <Update />,
        },
        {
            path: ':id/update-advanced',
            element: <UpdateAdvanced />,
        },
        {
            path: ':id/identity',
            element: <Identity />,
        },
        {
            path: 'departments/:id',
            element: <DepartmentDetail />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default EmployeeModule
